export type TSortByProps<T> = {
  additionalOptions?: Array<keyof T>;
  defaultOption?: DefaultSortOptions | keyof T;
  isLoading?: boolean;
  queryParam?: string;
};

export enum DefaultSortOptions {
  LAST_MODIFIED = 'last_modified',
  CREATION_DATE_ASC = 'creation_date_asc',
  CREATION_DATE_DESC = 'creation_date_desc',
}
